import { AdminLevelFormI, ValidationSet } from '../../../../types/interface';
import { ValidationEnum } from 'utils/enums/validationEnums';

export const AdminLevelValidationSet: ValidationSet<AdminLevelFormI> = {
  level_name: [
    {
      type: ValidationEnum.REQUIRED,
      message: 'Please enter admin level name',
      key: 'validation.level.level_name'
    }
  ],
  level_name_german: [
    {
      type: ValidationEnum.REQUIRED,
      message: 'Please enter admin level name in German',
      key: 'validation.level.level_name_de'
    }
  ],
  level_order: [
    {
      type: ValidationEnum.REQUIRED,
      message: 'Please enter admin level order',
      key: 'validation.level.level_order'
    },
    {
      type: ValidationEnum.INTEGERVALIDATE,
      message: 'Please enter valid admin level order',
      key: 'validation.level.level_order_valid',
      expression: /^\d+$/
    },
    {
      type: ValidationEnum.MIN,
      message: 'Level order must be between 1 and 100',
      key: 'validation.level.level_order_range',
      value: 1
    },
    {
      type: ValidationEnum.MAX,
      message: 'Level order must be between 1 and 100',
      key: 'validation.level.level_order_range',
      value: 100
    }
  ],
  description_en: [],
  description_de: []
};
